module.exports = "/build/admin/images/android-chrome-192x192.f57e6e6d.png";